import React, { useEffect } from "react";

const Chatbot = () => {
  useEffect(() => {
    // Prevent script from loading multiple times
    if (!document.querySelector("script[src='https://www.gstatic.com/dialogflow-console/fast/messenger/bootstrap.js?v=1']")) {
      const script = document.createElement("script");
      script.src = "https://www.gstatic.com/dialogflow-console/fast/messenger/bootstrap.js?v=1";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div>
      <h1>Welcome to Our Website</h1>
      <p>Feel free to chat with our assistant below!</p>

      {/* Dialogflow Messenger Integration */}
      <df-messenger
        intent="WELCOME"
        chat-title="Sathi"
        agent-id="9803d8d9-705a-439d-8811-27e9e4e7b30c"
        language-code="en"
      ></df-messenger>

      {/* Chatbot Styling */}
      <style>
        {`
          df-messenger {
            --df-messenger-bot-message: #eceff1;  
            --df-messenger-button-titlebar-color: #007bff;  
            --df-messenger-button-titlebar-font-color: #ffffff;
            --df-messenger-chat-background-color: #ffffff; 
            --df-messenger-user-message: #007bff;  
            --df-messenger-user-message-font-color: #ffffff; 
            position: fixed;
            bottom: 16px;
            right: 16px;
            z-index: 1000;
          }
        `}
      </style>
    </div>
  );
};

export default Chatbot;
